import { useQuery } from '@tanstack/react-query';

import fetch from './fetch';

function useBankList() {
  const { cb, key } = fetch();

  const { data, isLoading, isSuccess, isError, refetch } = useQuery(key, cb);

  return { data, isLoading, isSuccess, isError, refetch };
}

export default useBankList;
